var map = {
	"./AED.svg": "76b1",
	"./ALL.svg": "e8c2",
	"./AMD.svg": "a322",
	"./ANG.svg": "53db",
	"./ARS.svg": "04f0",
	"./AUD.svg": "a4a1",
	"./AZN.svg": "3928",
	"./BAM.svg": "8c35",
	"./BBD.svg": "4d13",
	"./BDT.svg": "ebd9c",
	"./BGN.svg": "0f3a",
	"./BHD.svg": "9e09",
	"./BMD.svg": "4222",
	"./BND.svg": "8d7d",
	"./BOB.svg": "db96",
	"./BRL.svg": "d9da",
	"./BWP.svg": "53a9",
	"./CAD.svg": "27f9",
	"./CHF.svg": "61b3",
	"./CLP.svg": "79d1",
	"./CNY.svg": "1cbc",
	"./COP.svg": "cf8b",
	"./CRC.svg": "07e5",
	"./CZK.svg": "b98b",
	"./DJF.svg": "4b30",
	"./DKK.svg": "2bca",
	"./DOP.svg": "6634",
	"./EGP.svg": "b75a",
	"./EUR.svg": "81d3",
	"./GBP.svg": "2893",
	"./GEL.svg": "a4b3",
	"./GHS.svg": "7ad1",
	"./GTQ.svg": "cdf1",
	"./HKD.svg": "e398",
	"./HRK.svg": "6823",
	"./HUF.svg": "4f71",
	"./IDQ.svg": "1c5c",
	"./IDR.svg": "d9cb",
	"./ILS.svg": "59cc",
	"./INR.svg": "ad5f",
	"./IQD.svg": "adff",
	"./ISK.svg": "73c2",
	"./JMD.svg": "ee1a",
	"./JOD.svg": "f8d8",
	"./JPY.svg": "7874",
	"./KES.svg": "8da8",
	"./KGS.svg": "6d9e",
	"./KHR.svg": "7f05",
	"./KRW.svg": "928a",
	"./KWD.svg": "6cf1",
	"./KYD.svg": "9f77",
	"./KZT.svg": "85b5",
	"./LKR.svg": "1b61",
	"./MAD.svg": "06d8",
	"./MDL.svg": "21c6",
	"./MGA.svg": "6e05",
	"./MKD.svg": "51a9",
	"./MNT.svg": "b6b4",
	"./MOP.svg": "7f441",
	"./MUR.svg": "92b7",
	"./MXN.svg": "0912",
	"./MYR.svg": "36da",
	"./MZN.svg": "30c2",
	"./NAD.svg": "74c6",
	"./NGN.svg": "fdbe",
	"./NOK.svg": "088bc",
	"./NPR.svg": "bd58",
	"./NZD.svg": "946a",
	"./OMR.svg": "5da2",
	"./PAB.svg": "4bfa",
	"./PEN.svg": "25f9",
	"./PGK.svg": "ec0e",
	"./PHP.svg": "f568",
	"./PKR.svg": "cb06",
	"./PLN.svg": "e781",
	"./PYG.svg": "3548",
	"./QAR.svg": "eb77",
	"./RON.svg": "c1c1",
	"./RSD.svg": "23d4",
	"./RUB.svg": "b534",
	"./SAR.svg": "53a87",
	"./SEK.svg": "58a7",
	"./SGD.svg": "9e28",
	"./SOS.svg": "a6a4",
	"./THB.svg": "47d5f",
	"./TRY.svg": "5ca8",
	"./TWD.svg": "99ef",
	"./TZS.svg": "7fec",
	"./UAH.svg": "9e0e",
	"./UGX.svg": "3950",
	"./USD.svg": "6eec",
	"./UYU.svg": "ebb2",
	"./UZS.svg": "f8cf",
	"./VND.svg": "c63c",
	"./XAF.svg": "e7ff",
	"./XOF.svg": "017e",
	"./XPF.svg": "b1d8",
	"./YER.svg": "db08",
	"./ZAR.svg": "f919",
	"./ZMW.svg": "6ab3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1813";